import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import util from 'preact-util';

import DyrejournalSaleSearch from '../../components/dyrejournal/search';
import { appAlert } from '../../lib/dialogs';

@observer
class WorkSharingNewItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedVisitor: null,
            selectedAnimal: null,
            visitorAnimals: [],
        };
    }

    componentDidMount() {
        const { workSharingItemStore, saleStore } = this.props.stores;
        saleStore.updateKeyValue('visitorResults', []);
        saleStore.updateKeyValue('animalResults', []);
        workSharingItemStore.resetNewItem();
        // Auto-select first customer
        const { customers } = workSharingItemStore;
        if (customers.length > 0) {
            workSharingItemStore.updateObjectKeyValue('newWorkSharingItem', 'customer', customers[0].id);
        }
    }

    handleInputChange = (field) => (e) => {
        const { workSharingItemStore } = this.props.stores;
        workSharingItemStore.updateObjectKeyValue('newWorkSharingItem', field, e.target.value);
    }

    handleVisitorSelected = async (visitor) => {
        const { workSharingItemStore, animalStore } = this.props.stores;
        this.setState({ selectedVisitor: visitor, selectedAnimal: null, visitorAnimals: [] });

        if (visitor.cellphone) {
            workSharingItemStore.updateObjectKeyValue('newWorkSharingItem', 'contactPhone', visitor.cellphone);
        }
        if (visitor.firstname || visitor.lastname) {
            const contactName = `${visitor.firstname || ''} ${visitor.lastname || ''}`.trim();
            workSharingItemStore.updateObjectKeyValue('newWorkSharingItem', 'contactName', contactName);
        }
        if (visitor.address) {
            workSharingItemStore.updateObjectKeyValue('newWorkSharingItem', 'locationAddress', visitor.address);
        }
        if (visitor.postalcode) {
            workSharingItemStore.updateObjectKeyValue('newWorkSharingItem', 'locationPostalcode', visitor.postalcode);
        }
        if (visitor.place) {
            workSharingItemStore.updateObjectKeyValue('newWorkSharingItem', 'locationPlace', visitor.place);
        }

        if (visitor.id) {
            const animals = await animalStore.load({ query: { owner: visitor.id }, skipUpdate: true });
            this.setState({ visitorAnimals: animals || [] });
        }
    }

    handleRemoveVisitor = () => {
        const { workSharingItemStore } = this.props.stores;
        this.setState({ selectedVisitor: null, selectedAnimal: null, visitorAnimals: [] });
        workSharingItemStore.updateObjectKeyValue('newWorkSharingItem', 'contactPhone', '');
        workSharingItemStore.updateObjectKeyValue('newWorkSharingItem', 'contactName', '');
        workSharingItemStore.updateObjectKeyValue('newWorkSharingItem', 'locationAddress', '');
        workSharingItemStore.updateObjectKeyValue('newWorkSharingItem', 'locationPostalcode', '');
        workSharingItemStore.updateObjectKeyValue('newWorkSharingItem', 'locationPlace', '');
    }

    handleAnimalSelected = (animal) => {
        this.setState({ selectedAnimal: animal });
    }

    handleRemoveAnimal = () => {
        this.setState({ selectedAnimal: null });
    }

    visitorSearchResultsLine = (visitor, idx, selectedIndex) => {
        const isSelected = idx === selectedIndex;
        return (
            <div class={`d-flex flex-row justify-content-between p-2 ${isSelected ? 'bg-primary text-white' : ''}`}>
                <div>
                    <strong>{visitor.firstname} {visitor.lastname}</strong>
                    {visitor.cellphone && <span class='ms-2'>{visitor.cellphone}</span>}
                </div>
                <div>
                    {visitor.place && <small class='text-muted'>{visitor.place}</small>}
                </div>
            </div>
        );
    }

    handleCreateItem = async () => {
        const { workSharingItemStore } = this.props.stores;
        const { newWorkSharingItem } = workSharingItemStore;
        const { selectedVisitor, selectedAnimal } = this.state;

        if (!newWorkSharingItem.title) {
            (await appAlert('Tittel er påkrevd'));
            return;
        }

        const itemData = { ...newWorkSharingItem };
        if (selectedVisitor) {
            itemData.visitor = selectedVisitor.id;
        }
        if (selectedAnimal) {
            itemData.animal = selectedAnimal.id;
        }

        await workSharingItemStore.createItem(itemData);
        this.handleClose();
        if (this.props.callback) this.props.callback();
    }

    handleClose = () => {
        const { appState, workSharingItemStore, saleStore } = this.props.stores;
        const { drawerLevel = 1 } = this.props;
        workSharingItemStore.resetNewItem();
        saleStore.updateKeyValue('visitorResults', []);
        saleStore.updateKeyValue('animalResults', []);
        appState.toggleDrawer(false, drawerLevel);
    }

    render() {
        const { workSharingItemStore, visitorStore, userStore } = this.props.stores;
        const { newWorkSharingItem, customers } = workSharingItemStore;
        const { selectedVisitor, selectedAnimal, visitorAnimals } = this.state;
        const { user = {} } = userStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100 h-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>

                    {customers.length > 1 && (
                        <div class={`d-flex flex-column mx-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} px-4 py-3 mt-3`}>
                            <span class='text-muted font-weight-light'>Kunde *</span>
                            <select
                                class='form-select mt-1'
                                value={newWorkSharingItem.customer || ''}
                                onChange={this.handleInputChange('customer')}
                            >
                                {customers.map(c => (
                                    <option key={c.id} value={c.id}>{c.name}</option>
                                ))}
                            </select>
                        </div>
                    )}

                    {/* Visitor and Animal */}
                    <div class='w-100 d-flex flex-sm-row flex-column mt-0'>
                        <div class='w-100 d-flex flex-column'>
                            <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between mt-3'>
                                <h4 style='padding-bottom: 5px;'>Dyreeier</h4>
                            </div>
                            <div class={`d-flex flex-column mx-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} px-4 py-3`}>
                                {selectedVisitor ? (
                                    <div class='d-flex justify-content-between align-items-center'>
                                        <div>
                                            <div class='d-flex flex-row'>
                                                <span class='text-muted font-weight-light'>Fornavn</span>
                                                <span class='ms-2'><strong>{selectedVisitor.firstname}</strong></span>
                                            </div>
                                            <div class='d-flex flex-row'>
                                                <span class='text-muted font-weight-light'>Etternavn</span>
                                                <span class='ms-2'><strong>{selectedVisitor.lastname}</strong></span>
                                            </div>
                                            {selectedVisitor.cellphone && (
                                                <div class='d-flex flex-row'>
                                                    <span class='text-muted font-weight-light'>Mobiltelefon</span>
                                                    <span class='ms-2'>{selectedVisitor.cellphone}</span>
                                                </div>
                                            )}
                                            {selectedVisitor.address && (
                                                <div class='d-flex flex-row'>
                                                    <span class='text-muted font-weight-light'>Adresse</span>
                                                    <span class='ms-2'>{selectedVisitor.address}, {selectedVisitor.postalcode} {selectedVisitor.place}</span>
                                                </div>
                                            )}
                                        </div>
                                        <button class='btn btn-sm btn-outline-danger rounded-pill' onClick={this.handleRemoveVisitor}>
                                            <i class='fa-solid fa-times' />
                                        </button>
                                    </div>
                                ) : (
                                    <DyrejournalSaleSearch
                                        stores={this.props.stores}
                                        holdingStore={visitorStore}
                                        searchResultList='visitorResults'
                                        title='Søk etter dyreeier (navn, telefon, epost)'
                                        searchResultsLine={this.visitorSearchResultsLine}
                                        callback={this.handleVisitorSelected}
                                        skipSaleUpdate={true}
                                    />
                                )}
                            </div>
                        </div>

                        {selectedVisitor && visitorAnimals.length > 0 && (
                            <div class='w-100 d-flex flex-column'>
                                <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between mt-3'>
                                    <h4 style='padding-bottom: 5px;'>Dyr</h4>
                                </div>
                                <div class={`d-flex flex-column mx-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} px-4 py-3`}>
                                    {selectedAnimal ? (
                                        <div class='d-flex justify-content-between align-items-center'>
                                            <div>
                                                <div class='d-flex flex-row'>
                                                    <span class='text-muted font-weight-light'>Navn</span>
                                                    <span class='ms-2'><strong>{selectedAnimal.name}</strong></span>
                                                </div>
                                                {selectedAnimal.species && (
                                                    <div class='d-flex flex-row'>
                                                        <span class='text-muted font-weight-light'>Art</span>
                                                        <span class='ms-2'>{selectedAnimal.species}</span>
                                                    </div>
                                                )}
                                                {selectedAnimal.breed && (
                                                    <div class='d-flex flex-row'>
                                                        <span class='text-muted font-weight-light'>Rase</span>
                                                        <span class='ms-2'>{selectedAnimal.breed}</span>
                                                    </div>
                                                )}
                                            </div>
                                            <button class='btn btn-sm btn-outline-danger rounded-pill' onClick={this.handleRemoveAnimal}>
                                                <i class='fa-solid fa-times' />
                                            </button>
                                        </div>
                                    ) : (
                                        <div class='d-flex flex-wrap gap-1'>
                                            {visitorAnimals.map(animal => (
                                                <button
                                                    key={animal.id}
                                                    class='btn btn-sm btn-outline-secondary rounded-pill'
                                                    onClick={() => this.handleAnimalSelected(animal)}
                                                >
                                                    <i class='fa-solid fa-paw me-1' />
                                                    {animal.name}
                                                    {animal.species && <span class='ms-1 text-muted'>({animal.species})</span>}
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Job details */}
                    <div class={`d-flex flex-column mx-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} px-4 py-3 mt-3`}>
                        <div class='mb-3'>
                            <span class='text-muted font-weight-light'>Tittel *</span>
                            <input
                                type='text'
                                class='form-control mt-1'
                                value={newWorkSharingItem.title || ''}
                                onInput={this.handleInputChange('title')}
                                placeholder='Kort beskrivelse av jobben'
                            />
                        </div>
                        <div class='mb-3'>
                            <span class='text-muted font-weight-light'>Beskrivelse</span>
                            <textarea
                                class='form-control mt-1'
                                rows='3'
                                value={newWorkSharingItem.description || ''}
                                onInput={this.handleInputChange('description')}
                                placeholder='Detaljert beskrivelse'
                            />
                        </div>
                        <div class='d-flex flex-sm-row flex-column gap-3'>
                            <div class='flex-fill'>
                                <span class='text-muted font-weight-light'>Prioritet</span>
                                <select
                                    class='form-select mt-1'
                                    value={newWorkSharingItem.priority || 'normal'}
                                    onChange={this.handleInputChange('priority')}
                                >
                                    <option value='low'>Lav</option>
                                    <option value='normal'>Normal</option>
                                    <option value='high'>Høy</option>
                                    <option value='urgent'>Haster</option>
                                </select>
                            </div>
                            <div class='flex-fill'>
                                <span class='text-muted font-weight-light'>Type jobb</span>
                                <select
                                    class='form-select mt-1'
                                    value={newWorkSharingItem.jobType || 'other'}
                                    onChange={this.handleInputChange('jobType')}
                                >
                                    <option value='consultation'>Konsultasjon</option>
                                    <option value='vaccination'>Vaksinering</option>
                                    <option value='emergency'>Akutt</option>
                                    <option value='surgery'>Kirurgi</option>
                                    <option value='checkup'>Kontroll</option>
                                    <option value='other'>Annet</option>
                                </select>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {/* Buttons */}
            <div class='d-flex justify-content-center gap-2 py-3'>
                <button class='btn btn-outline-secondary rounded-pill px-4' onClick={this.handleClose}>
                    Avbryt
                </button>
                <button class='btn btn-primary rounded-pill px-4' onClick={this.handleCreateItem}>
                    <i class='fa-solid fa-plus me-2' /> Opprett jobb
                </button>
            </div>
        </>);
    }
}

export default WorkSharingNewItem;
